import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/uiAccessControl";

export default function RequirePermission({ permission, children }) {
  if (!hasPermission(permission)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
}
